import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@material-ui/styles";
// component, hooks
import CustomProgress from "../../common/components/progress";
// store
import { StoreContext } from "../../store/StoreProvider";
import Act from "../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../config/CONSTANTS";
import urls from "../../api/project/ApiUrls";
import featureDisplay from "../../common/utils/featureDisplay";

// style
const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
}));

const MainLoading = () => {
  // props

  // route,intl

  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, common } = state;
  const { locale } = user;
  const { loader } = common;
  // local state
  const [localOpen, setLocalOpen] = useState(false);
  // hooks

  const handleClose = () => {
    // 使用者自己不能關閉
    // setOpen(false);
  };

  useEffect(() => {
    setLocalOpen(loader.open);
  }, [loader]);

  // 是否要顯示 loader 的 value(0-100): 50 => loader 會呈現半圓形
  const showValue = loader?.value !== null && loader?.value !== undefined;

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={localOpen}
        onClick={handleClose}
      >
        <CustomProgress.Circular showValue={showValue} value={loader.value} />
      </Backdrop>
    </div>
  );
};

MainLoading.propTypes = {};

MainLoading.defaultProps = {};

export default MainLoading;
